// PROP-TNT-REL-CHK
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';
import IsTypeOfPayment from '../rules/IsTypeOfPayment';

class MaturityPaymentAcknowledgementRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    return IsTypeOfPayment.setType('maturity').evaluate(data)
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new MaturityPaymentAcknowledgementRuleset();
